import React, {useEffect, useRef, useState} from 'react';
import SwiperCore, {Navigation, Pagination, A11y} from 'swiper';
import {Swiper, SwiperSlide} from 'swiper/react';
import {
    ReviewImagesBeforeArrow,
    ReviewImagesAfterArrow,
    DownArrowReview,
} from '../../../../assets/Arrows.jsx';
// import 'swiper/swiper.scss';
import '../../ProductContent/ProductContent.scss';
import './contentComponent.scss';

import {moveToLink, stringLineBreak} from '../../../utils/utils.js';
import TrackVisibility from 'react-on-screen';
import VisibilitySensor from 'react-visibility-sensor';

import LinkIcon from '../../../../img/mo-icon-text-link-orange.svg'

import InfoAccordion from '../../InfoAccordion/InfoAccordion.component.jsx';
import {breakpointDt, breakpointDt_mid} from '../../../constants/constants.js';

SwiperCore.use([Navigation, Pagination, A11y]);

export const ObjInsideImg = ({textObj = undefined, bgImgMo, bgImgDt, isFullInMo = false}) => {
    // 컴포넌트 동작 배경이미지 데스크탑, 모바일 등장
    // 모바일인 경우 vw 100
    // 데스크탑인 경우 vw 50
    // 컨텐츠의 부모 컴포넌트가 가운데 세로 정렬이 되어야 함
    // const wrapperRef = useRef();
    // const curImg =useRef();

    //   const handleImgResponsiveChange = () =>{
    //     if(wrapperRef.current){
    //       if(window.innerWidth < breakpointDt ){
    //         wrapperRef.current.style.backgroundImage = `url(${bgImgMo})`;
    //       } else{
    //         wrapperRef.current.style.backgroundImage = `url(${bgImgDt})`;
    //       }

    //     }

    //   };
    //   window.addEventListener('resize', handleImgResponsiveChange);
    //   handleImgResponsiveChange();
    //   return () =>{
    //     window.removeEventListener('resize', handleImgResponsiveChange);
    //   };
    // }, []);

    return (
        <TrackVisibility once partialVisibility>
            {({isVisible}) => {
                return (
                    <div
                        className="objInsideImgWrapper"
                        style={{
                            transform: isVisible ? '' : 'translateY(80px)',
                            opacity: isVisible ? 1 : 0,
                            transition: 'transform 1s ease-out, opacity 1s linear',
                        }}
                    >
                        <div
                            className="contentWrapper"
                            style={{
                                maxWidth: isFullInMo ? 'unset' : '',
                            }}
                        >
                            <img src={bgImgMo} className="bgImgMo" alt=""/>
                            <img src={bgImgDt} className="bgImgDt" alt=""/>
                            <div className="textObj">{textObj}</div>
                        </div>
                    </div>
                );
            }}
        </TrackVisibility>
    );
};

export const TextAndCarousel = ({
                                    headText = undefined,
                                    headDesc = undefined,
                                    headDescJsx = undefined,
                                    imageObjArr = undefined,
                                    paginationId = undefined,
                                    badgeText = undefined,
                                    isPagination = undefined,
                                    isLink = undefined,
                                    navButtonVisible = true,
                                    threshold = undefined,
                                    colorDesc = undefined,
                                    textureDesc = undefined,
                                    withAnimation = false,
                                    isLoop = false,
                                    isHome = false,
                                    isIndicate = false,
                                    gab = undefined,
                                    trigger = undefined,
                                    setSwiperInfo = undefined,
                                    isBullet = false
                                }) => {
    const [isVisible, setIsVisible] = useState(false);

    const visibleHandler = (evt) => {
        setIsVisible(evt);
    };
    return (
        <div className="textAndCarousel">
            <div className="content-wrapper">
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => {
            return (
              <h2
                className="textAndCarouselHeadText"
                style={{
                  transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                  opacity: isVisible || !withAnimation ? 1 : 0,
                  transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                }}
              >
                {headText && stringLineBreak(headText)}
                {badgeText && <div className="textAndCarouselBadgeText"> {badgeText} </div>}
              </h2>
            );
          }}
        </TrackVisibility> */}
                {(headText || badgeText) &&
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <h2
                            id="carouselElement1"
                            className={`textAndCarouselHeadText carouselAnimation ${isVisible && 'onShow'}`}
                        >
                            {headText && stringLineBreak(headText)}
                            {badgeText && <div className="textAndCarouselBadgeText"> {badgeText} </div>}
                        </h2>
                    </VisibilitySensor>}
                {headDesc && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <p
                    //         className="textAndCarouselHeadDesc"
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         {stringLineBreak(headDesc)}
                    //       </p>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <p className={`carouselAnimation textAndCarouselHeadDesc ${isVisible && 'onShow'}`}>
                            {stringLineBreak(headDesc)}
                        </p>
                    </VisibilitySensor>
                )}
                {headDescJsx && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <div
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         {headDescJsx}
                    //       </div>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <div className={`carouselAnimation ${isVisible && 'onShow'}`}>{headDescJsx}</div>
                    </VisibilitySensor>
                )}
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => {
            return (
              <div
                className="textAndCarouselSwiper  section-swiper-container"
                style={{
                  transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                  opacity: isVisible || !withAnimation ? 1 : 0,
                  transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                }}
              >
                <Swiper
                  spaceBetween={16}
                  slidesPerView={1}
                  // draggable={isNonDraggable ? false : true}
                  threshold={threshold ? threshold : 0}
                  centeredSlides={true}
                  centeredSlidesBounds={true}
                  updateOnWindowResize={true}
                  pagination={
                    isPagination
                      ? { el: `.swiper-pagination${paginationId}` }
                      : { el: 'shoudnotbeused' }
                  }
                  navigation={{
                    // 컴포넌트마다 다른 네비게이션 엘리먼트를 사용해야 함 그래야 다른거에 이벤트가 붙을듯
                    nextEl: `.swiper-button-next-content.${paginationId}`,
                    prevEl: `.swiper-button-prev-content.${paginationId}`,
                  }}
                >
                  {imageObjArr &&
                    imageObjArr.map((imgObj, i) => {
                      return (
                        <SwiperSlide key={i}>
                          <div
                            style={{
                              width: '100%',
                              cursor: isLink ? 'pointer' : '',
                            }}
                          >
                            <img
                              src={imgObj.img}
                              className="section-image "
                              onClick={(e) => {
                                if (!isLink) {
                                  return;
                                }
                                if (imgObj.link) {
                                  moveToLink(imgObj.link, e);
                                } else {
                                  // 지금 콜렉션 페이지라면 앵커를 가진 채로 새로고침
                                  // alert(imgObj.collectionSlug);
                                  // if(window.location.pathname.includes('collection')){
                                  //   location.href = `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`;
                                  //   // history.go(0);
                                  // } else {
                                  if (
                                    window.location.pathname ===
                                    `/collection/${imgObj.collectionSlug}`
                                  ) {
                                    window.href = `#${imgObj.anchor}`;
                                    history.go(0);
                                    window.location.reload();
                                  } else {
                                    moveToLink(
                                      `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`,
                                      e
                                    );
                                  }

                                  // }
                                }
                                // moveToLink(`${imgObj.link}#${imgObj.anchor}`);
                              }}
                            />
                            {imgObj.text && (
                              <div className="textAndCarouselSwiperImgDesc">
                                {stringLineBreak(imgObj.text)}
                              </div>
                            )}
                            {imgObj.subText && (
                              <div className="textAndCarouselSwiperImgSubDesc">
                                {stringLineBreak(imgObj.subText)}
                              </div>
                            )}
                            {imgObj.outerLink &&
                              imgObj.outerLink.map((link, idx) => {
                                return (
                                  <a key={idx} className="mediaContentsOuterLink" href={link.link}>
                                    <div>{link.text}</div>
                                    <img src="/img/mo-icon-text-link-orange.svg" />
                                  </a>
                                );
                              })}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                </Swiper>
              </div>
            );
          }}
        </TrackVisibility> */}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`textAndCarouselSwiper  section-swiper-container carouselAnimation ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <Swiper
                            spaceBetween={gab ? gab : 16}
                            slidesPerView={1}
                            onSlideChange={(target) => {
                                trigger && trigger();
                                setSwiperInfo && setSwiperInfo(target)
                            }}
                            // draggable={isNonDraggable ? false : true}
                            threshold={threshold ? threshold : 0}
                            centeredSlides={true}
                            centeredSlidesBounds={true}
                            updateOnWindowResize={true}
                            pagination={
                                isBullet ? {
                                    type: 'bullets',
                                    clickable: true
                                } : isPagination
                                    ? {el: `.swiper-pagination${paginationId}`}
                                    : {el: 'shoudnotbeused'}
                            }
                            navigation={{
                                // 컴포넌트마다 다른 네비게이션 엘리먼트를 사용해야 함 그래야 다른거에 이벤트가 붙을듯
                                nextEl: `.swiper-button-next-content.${paginationId}`,
                                prevEl: `.swiper-button-prev-content.${paginationId}`,
                            }}
                            loop={isLoop}
                            loopAdditionalSlides={isLoop ? 1 : 0}
                            breakpoints={{
                                768: {
                                    slidesPerView: isHome ? 2 : 1,
                                    spaceBetween: isHome ? 24 : 16,
                                },
                                1200: {
                                    slidesPerView: isHome ? 3 : 1,
                                    spaceBetween: isHome ? 32 : 16,
                                },
                            }}
                        >
                            {imageObjArr &&
                                imageObjArr.map((imgObj, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    cursor: isLink ? 'pointer' : '',
                                                }}
                                            >
                                                <img
                                                    src={imgObj.img}
                                                    className="section-image "
                                                    onClick={(e) => {
                                                        if (!isLink) {
                                                            return;
                                                        }
                                                        if (imgObj.link) {
                                                            moveToLink(imgObj.link, e);
                                                        } else {
                                                            if (
                                                                window.location.pathname === `/collection/${imgObj.collectionSlug}`
                                                            ) {
                                                                window.href = `#${imgObj.anchor}`;
                                                                history.go(0);
                                                                window.location.reload();
                                                            } else {
                                                                moveToLink(
                                                                    `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`,
                                                                    e
                                                                );
                                                            }

                                                            // }
                                                        }
                                                        // moveToLink(`${imgObj.link}#${imgObj.anchor}`);
                                                    }}
                                                />
                                                {imgObj.text && (
                                                    <div className="textAndCarouselSwiperImgDesc">
                                                        {stringLineBreak(imgObj.text)}
                                                    </div>
                                                )}
                                                {imgObj.subText && (
                                                    <div className="textAndCarouselSwiperImgSubDesc">
                                                        {stringLineBreak(imgObj.subText)}
                                                    </div>
                                                )}
                                                {imgObj.outerLink &&
                                                    imgObj.outerLink.map((link, idx) => {
                                                        return (
                                                            <a key={idx} className="mediaContentsOuterLink"
                                                               href={link.link}>
                                                                <div>{link.text}</div>
                                                                <img src={LinkIcon}/>
                                                            </a>
                                                        );
                                                    })}
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                    </div>
                </VisibilitySensor>
                {colorDesc && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <div
                    //         className="textAndCarouselColorDesc"
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         <div>{colorDesc}</div>
                    //         <div>{textureDesc}</div>
                    //       </div>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <div className={`textAndCarouselColorDesc carouselAnimation ${isVisible && 'onShow'}`}>
                            <div>{colorDesc}</div>
                            <div>{textureDesc}</div>
                        </div>
                    </VisibilitySensor>
                )}
            </div>
            {isPagination && <div className={`swiper-pagination${paginationId}`}></div>}
            <div
                className={paginationId}
                style={{
                    visibility: navButtonVisible ? 'visible' : 'hidden',
                }}
            >
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => (
            <div
              className={`swiper-button-prev-content ${paginationId}`}
              style={{
                // transform:  isVisible? '' : 'translateY(80px)',
                // opacity: isVisible ? 1 : 0 ,
                transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
              }}
            >
              <ReviewImagesBeforeArrow />
            </div>
          )}
        </TrackVisibility> */}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation swiper-button-prev-content ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <ReviewImagesBeforeArrow/>
                    </div>
                </VisibilitySensor>
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => (
            <div
              className={`swiper-button-next-content ${paginationId}`}
              style={{
                // transform:  isVisible? '' : 'translateY(80px)',
                // opacity: isVisible ? 1 : 0 ,
                transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
              }}
            >
              <ReviewImagesAfterArrow />
            </div>
          )}
        </TrackVisibility> */}{isIndicate &&
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation indicate ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >

                    </div>
                </VisibilitySensor>}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation swiper-button-next-content ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <ReviewImagesAfterArrow/>
                    </div>
                </VisibilitySensor>
            </div>
        </div>
    );
};


export const TextAndCarouselWebp = ({
                                        headText = undefined,
                                        headDesc = undefined,
                                        headDescJsx = undefined,
                                        imageObjArr = undefined,
                                        paginationId = undefined,
                                        badgeText = undefined,
                                        isPagination = undefined,
                                        isLink = undefined,
                                        navButtonVisible = true,
                                        threshold = undefined,
                                        colorDesc = undefined,
                                        textureDesc = undefined,
                                        withAnimation = false,
                                        isLoop = false,
                                        isHome = false,
                                        isIndicate = false,
                                        gab = undefined,
                                        trigger = undefined,
                                        setSwiperInfo = undefined,
                                    }) => {
    const [isVisible, setIsVisible] = useState(false);

    const visibleHandler = (evt) => {
        setIsVisible(evt);
    };
    return (
        <div className="textAndCarousel">
            <div className="content-wrapper">
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => {
            return (
              <h2
                className="textAndCarouselHeadText"
                style={{
                  transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                  opacity: isVisible || !withAnimation ? 1 : 0,
                  transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                }}
              >
                {headText && stringLineBreak(headText)}
                {badgeText && <div className="textAndCarouselBadgeText"> {badgeText} </div>}
              </h2>
            );
          }}
        </TrackVisibility> */}
                {(headText || badgeText) &&
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <h2
                            id="carouselElement1"
                            className={`textAndCarouselHeadText carouselAnimation ${isVisible && 'onShow'}`}
                        >
                            {headText && stringLineBreak(headText)}
                            {badgeText && <div className="textAndCarouselBadgeText"> {badgeText} </div>}
                        </h2>
                    </VisibilitySensor>}
                {headDesc && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <p
                    //         className="textAndCarouselHeadDesc"
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         {stringLineBreak(headDesc)}
                    //       </p>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <p className={`carouselAnimation textAndCarouselHeadDesc ${isVisible && 'onShow'}`}>
                            {stringLineBreak(headDesc)}
                        </p>
                    </VisibilitySensor>
                )}
                {headDescJsx && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <div
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         {headDescJsx}
                    //       </div>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <div className={`carouselAnimation ${isVisible && 'onShow'}`}>{headDescJsx}</div>
                    </VisibilitySensor>
                )}
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => {
            return (
              <div
                className="textAndCarouselSwiper  section-swiper-container"
                style={{
                  transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                  opacity: isVisible || !withAnimation ? 1 : 0,
                  transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                }}
              >
                <Swiper
                  spaceBetween={16}
                  slidesPerView={1}
                  // draggable={isNonDraggable ? false : true}
                  threshold={threshold ? threshold : 0}
                  centeredSlides={true}
                  centeredSlidesBounds={true}
                  updateOnWindowResize={true}
                  pagination={
                    isPagination
                      ? { el: `.swiper-pagination${paginationId}` }
                      : { el: 'shoudnotbeused' }
                  }
                  navigation={{
                    // 컴포넌트마다 다른 네비게이션 엘리먼트를 사용해야 함 그래야 다른거에 이벤트가 붙을듯
                    nextEl: `.swiper-button-next-content.${paginationId}`,
                    prevEl: `.swiper-button-prev-content.${paginationId}`,
                  }}
                >
                  {imageObjArr &&
                    imageObjArr.map((imgObj, i) => {
                      return (
                        <SwiperSlide key={i}>
                          <div
                            style={{
                              width: '100%',
                              cursor: isLink ? 'pointer' : '',
                            }}
                          >
                            <img
                              src={imgObj.img}
                              className="section-image "
                              onClick={(e) => {
                                if (!isLink) {
                                  return;
                                }
                                if (imgObj.link) {
                                  moveToLink(imgObj.link, e);
                                } else {
                                  // 지금 콜렉션 페이지라면 앵커를 가진 채로 새로고침
                                  // alert(imgObj.collectionSlug);
                                  // if(window.location.pathname.includes('collection')){
                                  //   location.href = `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`;
                                  //   // history.go(0);
                                  // } else {
                                  if (
                                    window.location.pathname ===
                                    `/collection/${imgObj.collectionSlug}`
                                  ) {
                                    window.href = `#${imgObj.anchor}`;
                                    history.go(0);
                                    window.location.reload();
                                  } else {
                                    moveToLink(
                                      `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`,
                                      e
                                    );
                                  }

                                  // }
                                }
                                // moveToLink(`${imgObj.link}#${imgObj.anchor}`);
                              }}
                            />
                            {imgObj.text && (
                              <div className="textAndCarouselSwiperImgDesc">
                                {stringLineBreak(imgObj.text)}
                              </div>
                            )}
                            {imgObj.subText && (
                              <div className="textAndCarouselSwiperImgSubDesc">
                                {stringLineBreak(imgObj.subText)}
                              </div>
                            )}
                            {imgObj.outerLink &&
                              imgObj.outerLink.map((link, idx) => {
                                return (
                                  <a key={idx} className="mediaContentsOuterLink" href={link.link}>
                                    <div>{link.text}</div>
                                    <img src="/img/mo-icon-text-link-orange.svg" />
                                  </a>
                                );
                              })}
                          </div>
                        </SwiperSlide>
                      );
                    })}
                </Swiper>
              </div>
            );
          }}
        </TrackVisibility> */}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`textAndCarouselSwiper  section-swiper-container carouselAnimation ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <Swiper
                            spaceBetween={gab ? gab : 16}
                            slidesPerView={1}
                            onSlideChange={(target) => {
                                trigger && trigger();
                                setSwiperInfo && setSwiperInfo(target)
                            }}
                            // draggable={isNonDraggable ? false : true}
                            threshold={threshold ? threshold : 0}
                            centeredSlides={true}
                            centeredSlidesBounds={true}
                            updateOnWindowResize={true}
                            pagination={
                                (isPagination
                                    ? {el: `.swiper-pagination${paginationId}`}
                                    : {el: 'shoudnotbeused'})
                            }
                            navigation={{
                                // 컴포넌트마다 다른 네비게이션 엘리먼트를 사용해야 함 그래야 다른거에 이벤트가 붙을듯
                                nextEl: `.swiper-button-next-content.${paginationId}`,
                                prevEl: `.swiper-button-prev-content.${paginationId}`,
                            }}
                            loop={isLoop}
                            loopAdditionalSlides={isLoop ? 1 : 0}
                            breakpoints={{
                                768: {
                                    slidesPerView: isHome ? 2 : 1,
                                    spaceBetween: isHome ? 24 : 16,
                                },
                                1200: {
                                    slidesPerView: isHome ? 3 : 1,
                                    spaceBetween: isHome ? 32 : 16,
                                },
                            }}
                        >
                            {imageObjArr &&
                                imageObjArr.map((imgObj, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div
                                                style={{
                                                    width: '100%',
                                                    cursor: isLink ? 'pointer' : '',
                                                }}
                                            >
                                                <picture>
                                                    <source srcSet={imgObj.webpImg} type={"image/webp"}/>
                                                    <img
                                                        loading={i > 1 ? 'lazy' : "eager"}
                                                        src={imgObj.img}
                                                        className="section-image "
                                                        onClick={(e) => {
                                                            if (!isLink) {
                                                                return;
                                                            }
                                                            if (imgObj.link) {
                                                                moveToLink(imgObj.link, e);
                                                            } else {
                                                                if (
                                                                    window.location.pathname === `/collection/${imgObj.collectionSlug}`
                                                                ) {
                                                                    window.href = `#${imgObj.anchor}`;
                                                                    history.go(0);
                                                                    window.location.reload();
                                                                } else {
                                                                    moveToLink(
                                                                        `/collection/${imgObj.collectionSlug}#${imgObj.anchor}`,
                                                                        e
                                                                    );
                                                                }

                                                                // }
                                                            }
                                                            // moveToLink(`${imgObj.link}#${imgObj.anchor}`);
                                                        }}
                                                    />
                                                </picture>
                                                {imgObj.text && (
                                                    <div className="textAndCarouselSwiperImgDesc">
                                                        {stringLineBreak(imgObj.text)}
                                                    </div>
                                                )}
                                                {imgObj.subText && (
                                                    <div className="textAndCarouselSwiperImgSubDesc">
                                                        {stringLineBreak(imgObj.subText)}
                                                    </div>
                                                )}
                                                {imgObj.outerLink &&
                                                    imgObj.outerLink.map((link, idx) => {
                                                        return (
                                                            <a key={idx} className="mediaContentsOuterLink"
                                                               href={link.link}>
                                                                <div>{link.text}</div>
                                                                <img src={LinkIcon}/>
                                                            </a>
                                                        );
                                                    })}
                                            </div>
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                    </div>
                </VisibilitySensor>
                {colorDesc && (
                    // <TrackVisibility once partialVisibility>
                    //   {({ isVisible }) => {
                    //     return (
                    //       <div
                    //         className="textAndCarouselColorDesc"
                    //         style={{
                    //           transform: isVisible || !withAnimation ? '' : 'translateY(80px)',
                    //           opacity: isVisible || !withAnimation ? 1 : 0,
                    //           transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
                    //         }}
                    //       >
                    //         <div>{colorDesc}</div>
                    //         <div>{textureDesc}</div>
                    //       </div>
                    //     );
                    //   }}
                    // </TrackVisibility>
                    <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                        <div className={`textAndCarouselColorDesc carouselAnimation ${isVisible && 'onShow'}`}>
                            <div>{colorDesc}</div>
                            <div>{textureDesc}</div>
                        </div>
                    </VisibilitySensor>
                )}
            </div>
            {isPagination && <div className={`swiper-pagination${paginationId}`}></div>}
            <div
                className={paginationId}
                style={{
                    visibility: navButtonVisible ? 'visible' : 'hidden',
                }}
            >
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => (
            <div
              className={`swiper-button-prev-content ${paginationId}`}
              style={{
                // transform:  isVisible? '' : 'translateY(80px)',
                // opacity: isVisible ? 1 : 0 ,
                transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
              }}
            >
              <ReviewImagesBeforeArrow />
            </div>
          )}
        </TrackVisibility> */}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation swiper-button-prev-content ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <ReviewImagesBeforeArrow/>
                    </div>
                </VisibilitySensor>
                {/* <TrackVisibility once partialVisibility>
          {({ isVisible }) => (
            <div
              className={`swiper-button-next-content ${paginationId}`}
              style={{
                // transform:  isVisible? '' : 'translateY(80px)',
                // opacity: isVisible ? 1 : 0 ,
                transition: withAnimation ? 'transform 1s ease-out, opacity 1s linear' : '',
              }}
            >
              <ReviewImagesAfterArrow />
            </div>
          )}
        </TrackVisibility> */}{isIndicate &&
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation indicate ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >

                    </div>
                </VisibilitySensor>}
                <VisibilitySensor partialVisibility={true} onChange={visibleHandler} active={!isVisible}>
                    <div
                        className={`carouselAnimation swiper-button-next-content ${paginationId} ${
                            isVisible && 'onShow'
                        }`}
                    >
                        <ReviewImagesAfterArrow/>
                    </div>
                </VisibilitySensor>
            </div>
        </div>
    );
};

export const TextAndImagesAndDesc = ({
                                         headText = undefined,
                                         images = undefined,
                                         desc = undefined,
                                         badgeText = undefined,
                                         headDescJsx = undefined,
                                     }) => {
    return (
        <div className="imgAndDesc  ">
            <div className="content-wrapper">
                <TrackVisibility once partialVisibility>
                    {({isVisible}) => (
                        <h2
                            className="imgAndDescHeadText"
                            style={{
                                display: headText ? '' : 'none',
                                transform: isVisible ? '' : 'translateY(80px)',
                                opacity: isVisible ? 1 : 0,
                                transition: 'transform 1s ease-out, opacity 1s linear',
                            }}
                        >
                            {headText && stringLineBreak(headText)}
                            {badgeText && <div className="textAndCarouselBadgeText"> {badgeText} </div>}
                        </h2>
                    )}
                </TrackVisibility>

                {headDescJsx && (
                    <TrackVisibility once partialVisibility>
                        {({isVisible}) => (
                            <div
                                style={{
                                    transform: isVisible ? '' : 'translateY(80px)',
                                    opacity: isVisible ? 1 : 0,
                                    transition: 'transform 1s ease-out, opacity 1s linear',
                                }}
                            >
                                {headDescJsx}
                            </div>
                        )}
                    </TrackVisibility>
                )}
                <div className="imgAndDescImages">
                    {images &&
                        images.map((img, i) => {
                            return (
                                <TrackVisibility once partialVisibility key={i}>
                                    {({isVisible}) => (
                                        <img
                                            className={`imgAndDescImg img${i}`}
                                            style={{
                                                transform: isVisible ? '' : 'translateY(80px)',
                                                opacity: isVisible ? 1 : 0,
                                                transition: 'transform 1s ease-out, opacity 1s linear',
                                            }}
                                            src={img}
                                        />
                                    )}
                                </TrackVisibility>
                            );
                        })}
                </div>

                {desc && (
                    <TrackVisibility once partialVisibility>
                        {({isVisible}) => (
                            <div
                                className="desc"
                                style={{
                                    transform: isVisible ? '' : 'translateY(80px)',
                                    opacity: isVisible ? 1 : 0,
                                    transition: 'transform 1s ease-out, opacity 1s linear',
                                }}
                            >
                                {typeof desc === 'string' ? stringLineBreak(desc) : desc}
                            </div>
                        )}
                    </TrackVisibility>
                )}
            </div>
        </div>
    );
};

export const GoodsCommon = ({name}) => {
    return (
        <div className="GoodsIntroTexts"
             style={{backgroundImage: `url(${require('../../../../img/goods_intro_bg.png')})`}}>
            <div className="content-wrapper">
                <TrackVisibility once partialVisibility>
                    {({isVisible}) => (
                        <h2
                            className="GoodsHeadText"
                            style={{
                                transform: isVisible ? '' : 'translateY(80px)',
                                opacity: isVisible ? 1 : 0,
                                transition: 'transform 1s ease-out, opacity 1s linear',
                            }}
                        >
                            {name}의 <br/> 지극히 개인적인 <br/>
                            소품생활
                        </h2>
                    )}
                </TrackVisibility>

                <TrackVisibility once partialVisibility>
                    {({isVisible}) => (
                        <>
                            <p
                                className="GoodsDescription mo"
                                style={{
                                    transform: isVisible ? '' : 'translateY(80px)',
                                    opacity: isVisible ? 1 : 0,
                                    transition: 'transform 1s ease-out, opacity 1s linear',
                                }}
                            >
                                매일 똑같은 평범한 일상 속에서 작고, <br/>
                                잦은 행복을 느끼게 하는 것은 <br/>
                                언제나 {name === '당신' ? '당신과' : `${name}와`} 함께하는 작고 소소한
                                <br/>
                                소품일 거라 생각했어요.
                                <br/>
                                지극히 평범한 콜린스의 소품들이
                                <br/>
                                지극히 개인적인 {name}의 순간을 채워드릴게요.
                                <br/>
                            </p>

                            <p
                                className="GoodsDescription dt"
                                style={{
                                    transform: isVisible ? '' : 'translateY(80px)',
                                    opacity: isVisible ? 1 : 0,
                                    transition: 'transform 1s ease-out, opacity 1s linear',
                                }}
                            >
                                매일 똑같은 평범한 일상 속에서 작고, 잦은 행복을 느끼게 하는 것은
                                <br/>
                                언제나 {name === '당신' ? '당신과' : `${name}와`} 함께하는 작고 소소한 소품일 거라
                                생각했어요.
                                <br/>
                                지극히 평범한 콜린스의 소품들이
                                <br/>
                                지극히 개인적인 {name}의 순간을 채워드릴게요.
                                <br/>
                            </p>
                        </>
                    )}
                </TrackVisibility>
            </div>
            <TrackVisibility once partialVisibility>
                {({isVisible}) => (
                    <img
                        className="IntroImg"
                        style={{
                            transform: isVisible ? '' : 'translateY(80px)',
                            opacity: isVisible ? 1 : 0,
                            transition: 'transform 1s ease-out, opacity 1s linear',
                        }}
                        src={require('../../../../img/goods_intro_img.png')}
                        alt=""
                    />
                )}
            </TrackVisibility>
        </div>
    );
};
